import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, Button, Modal } from '@feathr/components';

interface ISaveChangesModalProps {
  opened: boolean;
  onClose: () => void;
  onSaveAndClose?: () => Promise<void>;
  isLoading?: boolean;
}

function SaveChangesModal({
  opened: isModalOpen,
  onClose: closeModal,
  onSaveAndClose,
  isLoading = false,
}: Readonly<ISaveChangesModalProps>): JSX.Element {
  const { t } = useTranslation();

  const handleSaveAndClose = async (): Promise<void> => {
    if (onSaveAndClose) {
      await onSaveAndClose();
    }
  };

  return (
    <Modal
      onClose={closeModal}
      opened={isModalOpen}
      rightActions={[
        <Button disabled={isLoading} key={'back'} onClick={closeModal}>
          {t('Back')}
        </Button>,
        <Button
          isLoading={isLoading}
          key={'save-and-close'}
          onClick={handleSaveAndClose}
          type={'primary'}
        >
          {t('Save and close')}
        </Button>,
      ]}
      size={'default'}
      title={t('Save changes?')}
    >
      <Alert
        description={t(
          'Changes to this geofilter set will impact all active campaigns that use this set. Ensure these changes are intentional, as they will be applied automatically across all related campaigns.',
        )}
        title={t('Warning')}
        type={'warning'}
      />
    </Modal>
  );
}

export default SaveChangesModal;
